import { HelpCategorySource } from './help-center.interface';

export const HELP_CATEGORIES: HelpCategorySource[] = [
  {
    id: 'introducao',
    titleKey: 'HELP.CAT.INTRODUCAO',
    icon: 'pi pi-compass',
    articles: [
      {
        id: 'cadastro-e-login',
        titleKey: 'HELP.CADASTRO_LOGIN.TITLE',
        summaryKey: 'HELP.CADASTRO_LOGIN.SUMMARY',
        categoryKey: 'HELP.CAT.INTRODUCAO_LABEL',
        contentKey: 'HELP.CADASTRO_LOGIN.CONTENT',
        icon: 'pi pi-key',
        keywords: [
          'login',
          'cadastro',
          'senha',
          'google',
          'microsoft',
          'entrar',
          'recuperar',
          'contexto',
          'estabelecimento',
          'sign up',
          'password',
          'sign in',
          'registro',
          'contraseña',
          'entrar',
          'inscription',
          'mot de passe',
          'connexion',
        ],
        routeContext: '/login',
      },
      {
        id: 'primeiro-acesso',
        titleKey: 'HELP.PRIMEIRO_ACESSO.TITLE',
        summaryKey: 'HELP.PRIMEIRO_ACESSO.SUMMARY',
        categoryKey: 'HELP.CAT.INTRODUCAO_LABEL',
        contentKey: 'HELP.PRIMEIRO_ACESSO.CONTENT',
        icon: 'pi pi-flag',
        keywords: [
          'primeiro acesso',
          'onboarding',
          'passo a passo',
          'inicio',
          'configurar',
          'first access',
          'setup',
          'primer acceso',
          'premier accès',
        ],
        routeContext: '/primeiro-acesso',
      },
    ],
  },
  {
    id: 'configuracoes',
    titleKey: 'HELP.CAT.CONFIGURACOES',
    icon: 'pi pi-building',
    articles: [
      {
        id: 'dados-estabelecimento',
        titleKey: 'HELP.DADOS_ESTABELECIMENTO.TITLE',
        summaryKey: 'HELP.DADOS_ESTABELECIMENTO.SUMMARY',
        categoryKey: 'HELP.CAT.CONFIGURACOES_LABEL',
        contentKey: 'HELP.DADOS_ESTABELECIMENTO.CONTENT',
        icon: 'pi pi-cog',
        keywords: [
          'estabelecimento',
          'endereço',
          'logo',
          'capa',
          'foto',
          'horario',
          'funcionamento',
          'abertura',
          'fechamento',
          'business',
          'address',
          'hours',
          'opening',
          'closing',
          'establecimiento',
          'horario',
          'établissement',
          'horaires',
        ],
        routeContext: '/estabelecimentos',
      },
      {
        id: 'gestao-profissionais',
        titleKey: 'HELP.GESTAO_PROFISSIONAIS.TITLE',
        summaryKey: 'HELP.GESTAO_PROFISSIONAIS.SUMMARY',
        categoryKey: 'HELP.CAT.CONFIGURACOES_LABEL',
        contentKey: 'HELP.GESTAO_PROFISSIONAIS.CONTENT',
        icon: 'pi pi-users',
        keywords: [
          'profissional',
          'equipe',
          'barbeiro',
          'almoço',
          'jornada',
          'comissão',
          'acesso',
          'senha',
          'perfil',
          'dono',
          'recepcao',
          'staff',
          'barber',
          'lunch',
          'commission',
          'equipo',
          'almuerzo',
          'équipe',
          'déjeuner',
        ],
        routeContext: '/estabelecimentos',
      },
      {
        id: 'servicos-categorias',
        titleKey: 'HELP.SERVICOS_CATEGORIAS.TITLE',
        summaryKey: 'HELP.SERVICOS_CATEGORIAS.SUMMARY',
        categoryKey: 'HELP.CAT.CONFIGURACOES_LABEL',
        contentKey: 'HELP.SERVICOS_CATEGORIAS.CONTENT',
        icon: 'pi pi-tags',
        keywords: [
          'serviço',
          'categoria',
          'preço',
          'valor',
          'duracao',
          'tempo',
          'barba',
          'corte',
          'service',
          'price',
          'duration',
          'servicio',
          'precio',
          'prestation',
          'prix',
        ],
        routeContext: '/estabelecimentos',
      },
      {
        id: 'conexao-whatsapp',
        titleKey: 'HELP.CONEXAO_WHATSAPP.TITLE',
        summaryKey: 'HELP.CONEXAO_WHATSAPP.SUMMARY',
        categoryKey: 'HELP.CAT.CONFIGURACOES_LABEL',
        contentKey: 'HELP.CONEXAO_WHATSAPP.CONTENT',
        icon: 'pi pi-whatsapp',
        keywords: [
          'whatsapp',
          'qr code',
          'notificação',
          'mensagem',
          'lembrete',
          'conectar',
          'automação',
          'notification',
          'reminder',
          'connect',
          'notificación',
          'recordatorio',
          'conectar',
          'notification',
          'rappel',
          'connecter',
        ],
        routeContext: '/estabelecimentos',
      },
    ],
  },
  {
    id: 'uso-diario',
    titleKey: 'HELP.CAT.USO_DIARIO',
    icon: 'pi pi-calendar',
    articles: [
      {
        id: 'gestao-agenda',
        titleKey: 'HELP.GESTAO_AGENDA.TITLE',
        summaryKey: 'HELP.GESTAO_AGENDA.SUMMARY',
        categoryKey: 'HELP.CAT.USO_DIARIO_LABEL',
        contentKey: 'HELP.GESTAO_AGENDA.CONTENT',
        icon: 'pi pi-calendar-plus',
        keywords: [
          'agenda',
          'agendamento',
          'marcar',
          'reagendar',
          'cancelar',
          'concluir',
          'status',
          'bloqueio',
          'folga',
          'almoço',
          'appointment',
          'schedule',
          'reschedule',
          'cancel',
          'block',
          'cita',
          'reagendar',
          'cancelar',
          'rendez-vous',
          'annuler',
          'bloquer',
        ],
        routeContext: '/agenda',
      },
      {
        id: 'clientes-dependentes',
        titleKey: 'HELP.CLIENTES_DEPENDENTES.TITLE',
        summaryKey: 'HELP.CLIENTES_DEPENDENTES.SUMMARY',
        categoryKey: 'HELP.CAT.USO_DIARIO_LABEL',
        contentKey: 'HELP.CLIENTES_DEPENDENTES.CONTENT',
        icon: 'pi pi-user-plus',
        keywords: [
          'cliente',
          'dependente',
          'filho',
          'parentesco',
          'titular',
          'paciente',
          'histórico',
          'customer',
          'dependent',
          'child',
          'cliente',
          'dependiente',
          'hijo',
          'client',
          'dépendant',
          'enfant',
        ],
        routeContext: '/agenda',
      },
      {
        id: 'dashboard-financeiro',
        titleKey: 'HELP.DASHBOARD_FINANCEIRO.TITLE',
        summaryKey: 'HELP.DASHBOARD_FINANCEIRO.SUMMARY',
        categoryKey: 'HELP.CAT.USO_DIARIO_LABEL',
        contentKey: 'HELP.DASHBOARD_FINANCEIRO.CONTENT',
        icon: 'pi pi-chart-bar',
        keywords: [
          'dashboard',
          'financeiro',
          'faturamento',
          'relatório',
          'comissão',
          'métricas',
          'meu financeiro',
          'revenue',
          'report',
          'commission',
          'financiero',
          'facturación',
          'informe',
          'financier',
          'chiffre',
          'rapport',
        ],
        routeContext: '/dashboard',
      },
      {
        id: 'agendamento-online',
        titleKey: 'HELP.AGENDAMENTO_ONLINE.TITLE',
        summaryKey: 'HELP.AGENDAMENTO_ONLINE.SUMMARY',
        categoryKey: 'HELP.CAT.USO_DIARIO_LABEL',
        contentKey: 'HELP.AGENDAMENTO_ONLINE.CONTENT',
        icon: 'pi pi-mobile',
        keywords: [
          'agendamento online',
          'link',
          'booking',
          'instagram',
          'bio',
          'cliente',
          'celular',
          '24h',
          'online booking',
          'reserva online',
          'réservation en ligne',
        ],
        routeContext: '/estabelecimentos',
      },
    ],
  },
  {
    id: 'faq',
    titleKey: 'HELP.CAT.FAQ',
    icon: 'pi pi-question-circle',
    articles: [
      {
        id: 'duvidas-frequentes',
        titleKey: 'HELP.DUVIDAS_FREQUENTES.TITLE',
        summaryKey: 'HELP.DUVIDAS_FREQUENTES.SUMMARY',
        categoryKey: 'HELP.CAT.FAQ_LABEL',
        contentKey: 'HELP.DUVIDAS_FREQUENTES.CONTENT',
        icon: 'pi pi-info-circle',
        keywords: [
          'faq',
          'dúvidas',
          'problemas',
          'ajuda',
          'suporte',
          'whatsapp cair',
          'trocar plano',
          'senha',
          'questions',
          'help',
          'support',
          'plan',
          'password',
          'dudas',
          'ayuda',
          'soporte',
          'plan',
          'questions',
          'aide',
          'assistance',
          'forfait',
        ],
      },
    ],
  },
];
